<div class="aspect-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
